import React, { forwardRef, useImperativeHandle, useState } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { PDFViewer } from '@react-pdf/renderer';

import { PalletPDF } from './PalletPDF';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'black',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, onProsseguir, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold', flex: 1 }}>
        {children}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        endIcon={<NavigateNextIcon />}
        size="small"
        onClick={onProsseguir}
      >
        Prosseguir
      </Button>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

// Preview do PDF de pallets/validades da compra — impressão/download ficam
// por conta dos controles do próprio visualizador de PDF do navegador; este
// diálogo só existe pra mostrar o conteúdo antes de prosseguir pra nota.
const DialogoPreviewPdfPallets = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [pallets, setPallets] = useState([]);
  const [aoFechar, setAoFechar] = useState(null);

  useImperativeHandle(ref, () => ({
    handleOpen(palletsLocal, aoFecharLocal) {
      setPallets(palletsLocal);
      // Guarda a função numa arrow, senão o useState entenderia que é um
      // updater funcional (state => novoState) em vez de um valor.
      setAoFechar(() => aoFecharLocal);
      setOpen(true);
    },
  }));

  function handleClose() {
    setOpen(false);
    if (aoFechar) aoFechar();
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialogo-preview-pdf-pallets"
      fullScreen
    >
      <DialogTitle onClose={handleClose} onProsseguir={handleClose}>
        Pallets e Validades da Compra
      </DialogTitle>
      <DialogContent dividers style={{ padding: 0, height: '100%' }}>
        {open ? (
          <PDFViewer style={{ width: '100%', height: '100%', border: 'none' }}>
            <PalletPDF pallets={pallets} />
          </PDFViewer>
        ) : null}
      </DialogContent>
    </Dialog>
  );
});

export default DialogoPreviewPdfPallets;
